import http from "./http";

class StatutsService {
    index(token){
        return http.get("/api/statut",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data, token){
        return http.post("/api/statut/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id, token){
        return http.get(`/api/statut/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id, token){
        return http.get(`/api/statut/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data, token){
        return http.post(`/api/statut/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id, token){
        return http.delete(`/api/statut/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    changeStatut(id,statut,table,token){
        return http.get(`/api/update/${id}/${table}/${statut}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new StatutsService()